export default __webpack_public_path__ + "static/media/video3.d3855825.png";